/* eslint-disable react/prefer-stateless-function */
import {utils} from '@wallaby-ui/core';
import PropTypes from 'prop-types';
import * as React from 'react';
import {injectIntl} from 'react-intl';
import {connect} from 'react-redux';

import ValidationMessage from './ValidationMessage';
import styles from './WithValidation.less';
import {
  hasError as hasErrorSelector,
  getValidationMessage,
} from 'src/js/containers/auto_layout/auto_layout_selectors';

/**
 * In case of error, this class renders localized validation message above the WrappedComponent.
 */
class WithValidation extends React.Component {
  render() {
    const {
      hasError,
      intl,
      message,
      WrappedComponent,
      wrappedChildren,
      ...restProps
    } = this.props;
    return (
      <div className={styles.dlWithValidation}>
        <ValidationMessage
          hasError={hasError}
          message={
            message ? utils.TranslateUtils.translate({id: message}, intl) : ''
          }
        />
        <WrappedComponent {...restProps} hasError={hasError}>
          {wrappedChildren}
        </WrappedComponent>
      </div>
    );
  }
}

WithValidation.displayName = 'WithValidation';

WithValidation.propTypes = {
  WrappedComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
    .isRequired,
  autoLayoutStateId: PropTypes.string.isRequired,
  screenId: PropTypes.string.isRequired,
  itemName: PropTypes.string.isRequired,
  wrappedChildren: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.any),
    PropTypes.object,
  ]),
};

WithValidation.defaultProps = {
  wrappedChildren: [],
};

export default connect((state, props) => ({
  hasError: hasErrorSelector(
    state,
    props.autoLayoutStateId,
    props.screenId,
    props.itemName
  ),
  message: getValidationMessage(
    state,
    props.autoLayoutStateId,
    props.screenId,
    props.itemName
  ),
}))(injectIntl(WithValidation));
